/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Pre_Render_Frame_Cache_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to pre-render frame cache. {error}" |
*
* @param {Pre_Render_Frame_Cache_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pre_render_frame_cache_failed_toast = /** @type {((inputs: Pre_Render_Frame_Cache_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Render_Frame_Cache_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de la pré-génération du cache d'images. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Vorrendern des Frame-Caches. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile pre-renderizzare la cache dei frame. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось предварительно отрендерить кэш кадров. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al precargar la caché de fotogramas. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`预渲染帧缓存失败。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`フレームキャッシュのプリレンダリングに失敗しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`फ्रेम कैश को प्री-रेंडर करने में विफल। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao pré-renderizar o cache de quadros. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to pre-render frame cache. ${i?.error}`)
});